import {
  FaChartBar,      // 대시보드(통계)
  FaIndustry,      // 생산 관리
  FaClipboardList, // 수주 관리
  FaCube,          // 제품 관리
  FaCogs,          // 공정 관리
  FaBoxes,         // 자재 재고 관리
  FaWarehouse,     // 완제품 재고 관리
  FaTools,         // 설비 관리
  FaHandshake,     // 거래처 관리
  FaExternalLinkAlt,
  FaTachometerAlt
} from 'react-icons/fa';
import logo from '../../images/Logo.png'; 
import './SideBar.css';
import { useLocation } from 'react-router-dom';
import ProductionManagement from '../../pages/ProductionManagement/ProductionManagement';
import ContractManagement from '../../pages/ContractManagement/ContractManagement';
import ProductManagement from '../../pages/ProductManagement/ProductManagement';
import ProcessManagement from '../../pages/ProcessManagement/ProcessManagement';
import MaterialManagement from '../../pages/MaterialManagement/MaterialManagement';
import ProductStockManagement from '../../pages/ProductStockManagement/ProductStockManagement';
import MachineManagement from '../../pages/MachineManagement/MachineManagement';
import PartnerManagement from '../../pages/PartnerManagement/PartnerManagement';
import { useUserAPI } from '../../api/user/useUserAPI';
import { TbLogout } from "react-icons/tb";
import KPI from '../../pages/KPI/KPI';
import Dashboard from '../../pages/Dashboard/Dashboard';
import StorageWidget from '../Storage/StorageWidget';
export const menuItems = {
  '대시보드': Dashboard,
  'KPI': KPI,
  '생산 관리': ProductionManagement,
  '수주 관리': ContractManagement,
  '제품 관리': ProductManagement,
  '완제품 재고 관리': ProductStockManagement,
  '자재 재고 관리': MaterialManagement,
  '공정 관리': ProcessManagement,
  '설비 관리': MachineManagement,
  '거래처 관리': PartnerManagement,
  '스마트라인플러스': '',
};

export const iconMap = {
  '생산 관리': FaIndustry,
  'KPI': FaChartBar,
  '수주 관리': FaClipboardList,
  '제품 관리': FaCube,
  '공정 관리': FaCogs,
  '자재 재고 관리': FaBoxes,
  '완제품 재고 관리': FaWarehouse,
  '설비 관리': FaTools,
  '거래처 관리': FaHandshake,
  '대시보드': FaTachometerAlt,
  '스마트라인플러스': FaExternalLinkAlt,
};

const routeMap = {
  '생산 관리': '/production',
  'KPI': '/kpi',
  '수주 관리': '/contract',
  '제품 관리': '/product',
  '완제품 재고 관리': '/product-stock',
  '자재 재고 관리': '/material',
  '공정 관리': '/process',
  '설비 관리': '/machine',
  '거래처 관리': '/partner',
  '대시보드': '/dashboard'
};
function SideBar({ isOpen, onSelectMenu, onHomeClick , session}) {
  const pathName = useLocation().pathname;
  const isBizMarker = session.data.dashboardPath === '/dashboard-smartbizmarker';
  const isSimpleLinePlus = pathName.startsWith('/simplelineplus');
  const userAPI = useUserAPI();
  const logOut = () => {
    userAPI.loginOut()
      .then(() => {
        window.location.href = '/login';
      })
      .catch((error) => {
        console.error('Logout failed:', error);
      });
  };
  
  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="logo clickable" onClick={onHomeClick}>
        {isSimpleLinePlus ? (
          <img src="/simplelineplus.png" alt="SimpleLine Plus" />
        ) : isBizMarker ? (
          <span className="brand-text-logo">SmartBizMaker</span>
        ) : (
          <img src={logo} alt="YC Logo" />
        )}
      </div>
      <div className="user-info">
        <div className="user-avatar">SA</div>
        <div className="user-details">
          <span className="user-name">{ session.data.companyName }</span>
          <span className="user-email">{ session.data.email }</span>
        </div>
        <div
          className="logout"
          role="button"
          tabIndex={0}
          aria-label="로그아웃"
          data-testid="logout-button"
          style={{ cursor: 'pointer' }}
          onClick={logOut}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); logOut(); } }}
        >
          <TbLogout className="logout-icon" />
        </div>
      </div>
      <nav>
        <ul className='side-ul'>
          {Object.keys(menuItems)
          .filter(k => k !== '스마트라인플러스' || !!session?.data.plus)
          .map((item, index) => {
            const Icon = iconMap[item] || FaCogs;
            const isActive = item === '대시보드'
              ? pathName.startsWith('/dashboard')
              : pathName === routeMap[item];
            return (
              <li
                key={index} 
                className={`menu-item ${ isActive ? 'active' : ''}`}
                onClick={() => onSelectMenu(item)}
              >
                <Icon className="menu-icon" />
                <span>{item}</span>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="sidebar-footer">
        <StorageWidget
          title={session.data.companyName}
        />
        <div className="sidebar-version">v{process.env.REACT_APP_VERSION || 'dev'}</div>
      </div>
    </div>
  );
}


export default SideBar;